import {Comment} from "@dv5/domain"
import React, {FC, useState} from "react"
import {ActionButtons, DeleteButton, EditButton} from "../buttons"
import {MultilineEditor} from "../inputs/multiline"
import {MarkdownViewer} from "../markdown/MarkdownViewer"
import './CommentItem.less'

interface Props {
    comment: Comment
    userName: string
    onEdit: (commentId: string, content: string) => void
    onDelete?: (commentId: string) => void
    compact?: boolean
    markdown?: boolean
}

export const CommentItem: FC<Props> = ({comment, userName, onEdit, onDelete, compact = false, markdown = false}) => {
    const [isEditing, setIsEditing] = useState(false)
    const [editContent, setEditContent] = useState('')

    const handleStartEdit = () => {
        setEditContent(comment.content)
        setIsEditing(true)
    }

    const handleSaveEdit = () => {
        if (!editContent.trim()) return
        onEdit(comment.id, editContent.trim())
        setIsEditing(false)
        setEditContent('')
    }

    const handleCancelEdit = () => {
        setIsEditing(false)
        setEditContent('')
    }

    return (
        <div className={`comment-dialog-comment-item${compact ? ' comment-dialog-comment-item--compact' : ''}`}>
            <div className="comment-header">
                <span className="comment-date">{comment.createdAt}</span>
                <span className="comment-author">{userName}</span>
                {!isEditing ? (
                    <div className="comment-actions">
                        <EditButton onEdit={handleStartEdit} />
                        {onDelete && <DeleteButton onDelete={() => onDelete(comment.id)} />}
                    </div>
                ) : null}
            </div>
            {isEditing ? (
                <div className="comment-edit-area">
                    <MultilineEditor
                        value={editContent}
                        setValue={setEditContent}
                        onConfirm={handleSaveEdit}
                        onCancel={handleCancelEdit}
                        settings={{autoFocus: true, autoResize: true}}
                        disabled={false}
                    />
                    <ActionButtons
                        onDone={handleSaveEdit}
                        onCancel={handleCancelEdit}
                    />
                </div>
            ) : markdown ? (
                <div className="comment-content comment-content--markdown">
                    <MarkdownViewer
                        sourceCode={comment.content}
                        compactMode={compact}
                        onToggleCheckBox={() => {}}
                    />
                </div>
            ) : (
                <div className="comment-content">{comment.content}</div>
            )}
        </div>
    )
}
